import { render } from "./ModalAlerta.vue?vue&type=template&id=08566694&scoped=true"
import script from "./ModalAlerta.vue?vue&type=script&lang=js"
export * from "./ModalAlerta.vue?vue&type=script&lang=js"

import "./ModalAlerta.vue?vue&type=style&index=0&id=08566694&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08566694"]])

export default __exports__